import type { ComponentProps } from 'react'
import { cn } from '@/utils/cn'

function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      className={cn('skeleton-shimmer rounded-lg', className)}
      aria-hidden
      {...props}
    />
  )
}

export { Skeleton }
